export default "__VITE_ASSET__2e022b53__"